// View-plane adapter that turns the expected-action form, summary, and draft
// factory into a registry `AnnotationTypeDef`. The only schema-specific casts
// in the editor live here, at the erased-`unknown` boundary.

import type { ExpectedActionDraft } from '../expectedAction/expectedAction.interface.js';
import { createEmptyDraft } from '../expectedAction/expectedActionDraft.js';
import { ExpectedActionForm } from '../expectedAction/ExpectedActionForm.js';
import { ExpectedActionSummary } from '../expectedAction/ExpectedActionSummary.js';

import type {
  AnnotationFormProps,
  AnnotationSummaryProps,
  AnnotationTypeDef,
} from './annotationType.interface.js';
import { EXPECTED_ACTION_PERSISTENCE } from './expectedActionPersistence.js';

const EXPECTED_ACTION_LABEL = 'Meeting Agent actions';
const EXPECTED_ACTION_DESCRIPTION =
  'Label the action the assistant should take after a turn.';
const ADD_EXPECTED_ACTION_LABEL = 'Add expected action';

function ExpectedActionFormAdapter({
  disabled,
  initialValue,
  onDone,
  onCancel,
  onDelete,
}: AnnotationFormProps) {
  return (
    <ExpectedActionForm
      disabled={disabled}
      initialValue={initialValue as ExpectedActionDraft | undefined}
      onDone={(draft) => onDone(draft)}
      onCancel={onCancel}
      onDelete={onDelete}
    />
  );
}

function ExpectedActionSummaryAdapter({
  draft,
  onEdit,
  onDelete,
}: AnnotationSummaryProps) {
  return (
    <ExpectedActionSummary
      draft={draft as ExpectedActionDraft}
      onEdit={onEdit}
      onDelete={onDelete}
    />
  );
}

/** The expected-action annotation type: the default (and currently only) type. */
export const EXPECTED_ACTION_TYPE: AnnotationTypeDef = {
  ...EXPECTED_ACTION_PERSISTENCE,
  label: EXPECTED_ACTION_LABEL,
  description: EXPECTED_ACTION_DESCRIPTION,
  addActionLabel: ADD_EXPECTED_ACTION_LABEL,
  createEmptyDraft,
  FormComponent: ExpectedActionFormAdapter,
  SummaryComponent: ExpectedActionSummaryAdapter,
};
